import {
  toWebshopApiError,
  WebshopApiErrorException,
  type WebshopApiError
} from '~/common/types/webshopApiError';

const DEFAULT_TECHNICAL_MESSAGE =
  'Ein technischer Fehler ist aufgetreten. Bitte laden Sie den Webshop neu!';

function getRequestUrl(input: Parameters<typeof fetch>[0]): string {
  if (typeof input === 'string') {
    return input;
  }
  if (input instanceof URL) {
    return input.toString();
  }
  return input.url;
}

export async function clientFetch(
  input: Parameters<typeof fetch>[0],
  init?: Parameters<typeof fetch>[1]
): Promise<Response> {
  const response = await fetch(input, init);
  if (response.ok) {
    return response;
  }

  const url = getRequestUrl(input);
  const apiError: WebshopApiError = await toWebshopApiError(response, DEFAULT_TECHNICAL_MESSAGE, url);

  if (apiError.status === 401 && typeof window !== 'undefined') {
    window.location.href = '/infra/auth/login';
  }

  throw new WebshopApiErrorException(apiError);
}
